// import colors from "assets/theme/base/colors";
import { Typography, Box } from "@mui/material";
import MDBox from "components/MDBox";
import React from "react";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getPointsTextColor, numberFormatter } from "utils/HelperFunctions";
import FlameIcon from "components/Icons/FlameIcon";
import { ReactComponent as WeeklyFireRingSVG } from "./fire_gradient_weekly_ring.svg";
import { ReactComponent as DailyFireRingSVG } from "./fire_gradient_daily_ring.svg";

function TargetPercentage({
  percentage,
  circularPercentage,
  width = "175px",
  height = "175px",
  percentageSuffix = "%",
  subTitle = "Completed",
  typographyVariant = "h4",
  strokeWidth = "13",
  outOfOffice = false,
  displayIcon = false,
  weeklyRing = false,
}) {
  const gradientId = `gradient-${weeklyRing ? "weekly" : "daily"}`;
  const chartPercentage = Math.round(outOfOffice ? 0 : circularPercentage || percentage || 0);
  const roundedDisplay = percentage ? Math.round(percentage) : 0;

  const renderDay = () => {
    if (outOfOffice) {
      return (
        <span
          className="material-symbols-outlined"
          style={{ fontSize: "1.6rem", color: "#efefef" }}
        >
          event_busy
        </span>
      );
    }
    let style = {};
    if (displayIcon && chartPercentage >= 100) {
      style = { color: "#f6c355", fontWeight: 700 };
    }
    return (
      <>
        <Typography variant={typographyVariant} sx={{ ...style, lineHeight: "1rem" }}>
          {numberFormatter(roundedDisplay)}
          {percentageSuffix}
        </Typography>
        {subTitle ? <Typography variant="subtitle2">{subTitle}</Typography> : null}
      </>
    );
  };

  return (
    <MDBox sx={{ position: "relative", width, height, display: "flex" }}>
      <div>
        {/* <svg style={{ position: "absolute", width: 0, height: 0 }}>
          <defs>
            <linearGradient id={gradientId} gradientTransform="rotate(90)">
              <stop offset="0%" stopColor="#ff750c" />
              <stop offset="100%" stopColor="#ffc538" />
            </linearGradient>
          </defs>
        </svg> */}
        <svg style={{ position: "absolute", width: 0, height: 0 }}>
          <defs>
            <pattern id={gradientId} patternUnits="userSpaceOnUse" width="100" height="100">
              {weeklyRing ? (
                <WeeklyFireRingSVG width="100" height="100" />
              ) : (
                <DailyFireRingSVG width="100" height="100" />
              )}
            </pattern>
          </defs>
        </svg>
        <CircularProgressbarWithChildren
          value={chartPercentage}
          styles={buildStyles({
            pathColor:
              chartPercentage >= 100
                ? `url(#${gradientId})`
                : getPointsTextColor(chartPercentage, outOfOffice),
            textSize: "1.2rem",
            textColor: `rgb(13,13,153)`,
            trailColor: outOfOffice ? "#efefef" : "#d6d6d6",
          })}
          strokeWidth={strokeWidth}
        >
          {renderDay()}
        </CircularProgressbarWithChildren>
      </div>
      {displayIcon && chartPercentage >= 100 && (
        <Box sx={{ position: "absolute", top: "32px", left: "32px" }}>
          <FlameIcon sx={{ width: "30px", height: "30px" }} />
        </Box>
      )}
    </MDBox>
  );
}

export default TargetPercentage;
